module.exports = __webpack_public_path__ + "img/money.92a78f59.jpg";